import React from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Header from "./components/Header";

var price = "";
var weekly = true;

export default class App extends React.Component {
  state = {
    modalShow: false,
    arabic: false,
  };

  setLang(lang, self) {
    if (lang === "ar") {
      self.setState({ arabic: true });
    } else {
      self.setState({ arabic: false });
    }
  }

  render() {
    var arabic = this.state.arabic;
    var modalShow = this.state.modalShow;

    return (
      <div>
        <Header arabic={this.state.arabic} setLang={this.setLang} self={this} />
        <div className="Hero">
          <div className="HeroGroup">
            <MyVerticallyCenteredModal
              show={modalShow}
              lang={arabic}
              onHide={() => this.setState({ modalShow: false })}
            />
            <CssBaseline />
            <Container
              maxWidth="lg"
              component="main"
              style={{ padding: "100px 0px 6px" }}
            >
              <Typography
                component="h1"
                variant="h2"
                align="center"
                color="textPrimary"
                gutterBottom
                className="myTitle"
                style={{ color: "white" }}
              >
                {arabic ? titles.aTitle : titles.title}
              </Typography>
              <Typography
                variant="h6"
                align="center"
                color="textSecondary"
                component="p"
                className="mySubtitle"
                style={{ color: "white" }}
              >
                {arabic ? titles.aSubtitle : titles.subtitle}
              </Typography>
              <br />

              <Typography
                variant="h6"
                align="center"
                color="textSecondary"
                component="p"
                className="myHadith"
                style={{ color: "white" }}
              >
                {arabic ? titles.aDescription : titles.description}
              </Typography>
              <br />
              <Container maxWidth="sm" component="main" style={{ width: 200 }}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  style={{
                    outline: "none",
                    color: "white",
                    borderColor: "white",
                  }}
                  onClick={() => {
                    this.setState({ modalShow: true });
                  }}
                >
                  {arabic ? titles.aDonate : titles.donate}
                </Button>
              </Container>
            </Container>
          </div>
        </div>

        <div style={{ padding: "50px 0px" }}>
          <Container
            maxWidth="md"
            component="footer"
            style={{ paddingBottom: 50 }}
          >
            <Typography
              component="h4"
              variant="h4"
              color="textPrimary"
              gutterBottom
              style={{
                direction: arabic ? "rtl" : "ltr",
                textAlign: arabic ? "right" : "left",
                color: "#31b55d",
              }}
            >
              {arabic ? titles.aLetterTitle : titles.letterTitle}
            </Typography>
            <br />
            <Typography
              variant="h6"
              color="textPrimary"
              component="p"
              style={{
                direction: arabic ? "rtl" : "ltr",
                textAlign: arabic ? "right" : "left",
              }}
            >
              {arabic ? titles.aLetterp1 : titles.letterp1}
              <br /> <br /> {arabic ? titles.aLetterp2 : titles.letterp2}
              <br />
              <br />
              {arabic ? titles.aLetterp3 : titles.letterp3} <br />
              <br />
              {arabic ? titles.aLetterp4 : titles.letterp4}
              <br />
              <br />
              {arabic ? titles.aLetterp5 : titles.letterp5}
              <br />
              <br />
              {arabic ? titles.aLetterp6 : titles.letterp6}
            </Typography>
          </Container>
          <Container maxWidth="sm" component="main" style={{ width: 200 }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              style={{
                outline: "none",
                color: "white",
                borderColor: "white",
              }}
              onClick={() => {
                this.setState({ modalShow: true });
              }}
            >
              {arabic ? titles.aDonate : titles.donate}
            </Button>
          </Container>
          <br />
          <Container
            maxWidth="md"
            component="footer"
            style={{
              borderTop: `1px solid rgba(0, 0, 0, 0.12)`,
              marginTop: 8,
              paddingTop: 50,
              paddingBottom: 50,
            }}
          >
            <Typography
              component="h4"
              variant="h4"
              color="textPrimary"
              gutterBottom
              style={{
                direction: arabic ? "rtl" : "ltr",
                textAlign: arabic ? "right" : "left",
                color: "#31b55d",
              }}
            >
              {arabic ? titles.aOperateTitle : titles.operateTitle}
            </Typography>
            <br />
            <Typography
              variant="h6"
              color="textPrimary"
              component="p"
              style={{
                direction: arabic ? "rtl" : "ltr",
                textAlign: arabic ? "right" : "left",
              }}
            >
              {arabic ? titles.aOperatep1 : titles.operatep1} <br />
              <br />
              {arabic ? titles.aOperatep2 : titles.operatep2}
              <br />
              <br /> {arabic ? titles.aOperatep3 : titles.operatep3}
            </Typography>
          </Container>
          <Container maxWidth="sm" component="main" style={{ width: 200 }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              style={{
                outline: "none",
                color: "white",
                borderColor: "white",
              }}
              onClick={() => {
                this.setState({ modalShow: true });
              }}
            >
              {arabic ? titles.aDonate : titles.donate}
            </Button>
          </Container>
          <br />
          <Container
            maxWidth="lg"
            component="footer"
            style={{
              borderTop: `1px solid rgba(0, 0, 0, 0.12)`,
              marginTop: 8,
              paddingTop: 50,
              paddingBottom: 50,
            }}
          >
            <Grid container spacing={4} justify="space-evenly">
              <Grid item lg={6} sm={6}>
                <Typography
                  variant="h6"
                  color="textPrimary"
                  gutterBottom
                  style={{
                    direction: arabic ? "rtl" : "ltr",
                    textAlign: arabic ? "right" : "left",
                  }}
                >
                  {arabic ? titles.aContact : titles.contact}
                </Typography>
                <small
                  id="emailHelp"
                  class="form-text text-muted"
                  style={{
                    direction: arabic ? "rtl" : "ltr",
                    textAlign: arabic ? "right" : "left",
                  }}
                >
                  {arabic ? titles.apurpose : titles.purpose}{" "}
                  <button
                    style={{
                      backgroundColor: "transparent",
                      borderStyle: "none",
                      color: "blue",
                      textDecoration: "underline",
                      padding: "0em",
                      outline: "none",
                    }}
                    onClick={() => {
                      this.setState({ modalShow: true });
                    }}
                  >
                    {arabic ? "هنا" : "here"}
                  </button>
                </small>
                <br />
                <Container maxWidth="md" component="main">
                  <form
                    action="https://formspree.io/waheedjensen@gmail.com"
                    method="POST"
                    style={{
                      direction: arabic ? "rtl" : "ltr",
                      textAlign: arabic ? "right" : "left",
                    }}
                  >
                    <div class="form-group">
                      <label for="exampleInputName1">
                        {arabic ? titles.aName : titles.name}
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputName1"
                        aria-describedby="nameHelp"
                        placeholder={
                          arabic ? titles.aNamePlace : titles.namePlace
                        }
                        name="Name"
                        style={{ outline: "none" }}
                      />
                    </div>
                    <div class="form-group">
                      <label for="exampleInputEmail1">
                        {arabic ? titles.aEmail : titles.email}
                      </label>
                      <input
                        type="email"
                        class="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        placeholder={
                          arabic ? titles.aEmailPlace : titles.emailPlace
                        }
                        name="Email"
                        style={{ outline: "none" }}
                      />
                      <small id="emailHelp" class="form-text text-muted">
                        {arabic ? titles.aShare : titles.share}
                      </small>
                    </div>
                    <div class="form-group">
                      <label for="exampleFormControlTextarea1">
                        {arabic ? titles.aMessage : titles.message}
                      </label>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        placeholder={
                          arabic ? titles.aMessagePlace : titles.messagePlace
                        }
                        name="Message"
                        style={{ outline: "none" }}
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      style={{ outline: "none" }}
                    >
                      {arabic ? "إرسال" : "Submit"}
                    </button>
                  </form>
                </Container>
              </Grid>
            </Grid>
            <Box mt={5}>
              <Copyright />
            </Box>
          </Container>
        </div>
      </div>
    );
  }
}

function MyVerticallyCenteredModal(props) {
  const [modalShow, setModalShow] = React.useState(false);
  const [weekShow, setWeekShow] = React.useState(false);
  const [tsShow, settsShow] = React.useState(false);

  if (!modalShow) {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          style={{
            direction: props.lang ? "rtl" : "ltr",
            textAlign: props.lang ? "right" : "left",
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{
              direction: props.lang ? "rtl" : "ltr",
              textAlign: props.lang ? "right" : "left",
            }}
          >
            {props.lang ? titles.aRecurring : titles.recurring}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 16 }}
            onClick={() => {
              setModalShow(true);
            }}
          >
            {props.lang ? titles.aYes : titles.yes}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              window.open("https://pay.superpayit.com/ssa-charity");
            }}
          >
            {props.lang ? titles.aNo : titles.no}
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  } else {
    if (!weekShow) {
      return (
        <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            style={{
              direction: props.lang ? "rtl" : "ltr",
              textAlign: props.lang ? "right" : "left",
            }}
          >
            <Modal.Title id="contained-modal-title-vcenter">
              {props.lang ? titles.aOften : titles.often}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                weekly = true;
                setWeekShow(true);
              }}
            >
              {props.lang ? titles.aWeekly : titles.weekly}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                weekly = false;
                setWeekShow(true);
              }}
            >
              {props.lang ? titles.aMonthly : titles.monthly}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setModalShow(false);
                settsShow(false);
                setWeekShow(false);
              }}
            >
              {props.lang ? titles.aBack : titles.back}
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={props.onHide}>Close</Button>
          </Modal.Footer>
        </Modal>
      );
    } else if (!tsShow) {
      return (
        <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            style={{
              direction: props.lang ? "rtl" : "ltr",
              textAlign: props.lang ? "right" : "left",
            }}
          >
            <Modal.Title id="contained-modal-title-vcenter">
              {props.lang ? titles.aMuch : titles.much}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                price = "$70";
                settsShow(true);
              }}
            >
              $70
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                price = "$35";
                settsShow(true);
              }}
            >
              $35
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                price = "$15";
                settsShow(true);
              }}
            >
              $15
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                price = "$10";
                settsShow(true);
              }}
            >
              $10
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setModalShow(false);
                settsShow(false);
                setWeekShow(false);
              }}
            >
              {props.lang ? titles.aBack : titles.back}
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={props.onHide}>Close</Button>
          </Modal.Footer>
        </Modal>
      );
    } else {
      return (
        <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            style={{
              direction: props.lang ? "rtl" : "ltr",
              textAlign: props.lang ? "right" : "left",
            }}
          >
            <Modal.Title id="contained-modal-title-vcenter">
              {props.lang ? titles.aTs : titles.ts}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                if (weekly) {
                  if (price === "$15") {
                    window.open("https://pay.superpayit.com/plan/B2fvPbU");
                  }
                  if (price === "$10") {
                    window.open("https://pay.superpayit.com/plan/PkXYJzo");
                  }
                  if (price === "$35") {
                    window.open("https://pay.superpayit.com/plan/oNcy9EE");
                  }

                  if (price === "$70") {
                    window.open("https://pay.superpayit.com/plan/j9rTWFA");
                  }
                } else {
                  if (price === "$15") {
                    window.open("https://pay.superpayit.com/plan/Q3bl4bQ");
                  }
                  if (price === "$10") {
                    window.open("https://pay.superpayit.com/plan/GJykBZs");
                  }
                  if (price === "$35") {
                    window.open("https://pay.superpayit.com/plan/pHh3PS0");
                  }

                  if (price === "$70") {
                    window.open("https://pay.superpayit.com/plan/mlNVK7A");
                  }
                }
              }}
            >
              {props.lang ? titles.aYes : titles.yes}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 16 }}
              onClick={() => {
                if (weekly) {
                  if (price === "$15") {
                    window.open("https://pay.superpayit.com/plan/CABhwuo");
                  }
                  if (price === "$10") {
                    window.open("https://pay.superpayit.com/plan/-eSqOY0");
                  }
                  if (price === "$35") {
                    window.open("https://pay.superpayit.com/plan/3lpsDPs");
                  }

                  if (price === "$70") {
                    window.open("https://pay.superpayit.com/plan/UzSSBMM");
                  }
                } else {
                  if (price === "$15") {
                    window.open("https://pay.superpayit.com/plan/CpTKuOs");
                  }
                  if (price === "$10") {
                    window.open("https://pay.superpayit.com/plan/bBkDl0Q");
                  }
                  if (price === "$35") {
                    window.open("https://pay.superpayit.com/plan/cLatuJ8");
                  }

                  if (price === "$70") {
                    window.open("https://pay.superpayit.com/plan/5ErcD3s");
                  }
                }
              }}
            >
              {props.lang ? titles.aNo : titles.no}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                settsShow(false);
                setModalShow(false);
                setWeekShow(false);
              }}
            >
              {props.lang ? titles.aBack : titles.back}
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={props.onHide}>Close</Button>
          </Modal.Footer>
        </Modal>
      );
    }
  }
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        One Soul
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// const useStyles = makeStyles((theme) => ({
//   "@global": {
//     ul: {
//       margin: 0,
//       padding: 0,
//       listStyle: "none",
//     },
//   },
//   appBar: {
//     backgroundColor: "transparent",
//     borderStyle: "None",
//     borderBottom: `1px solid ${theme.palette.divider}`,
//   },
//   toolbar: {
//     flexWrap: "wrap",
//   },
//   toolbarTitle: {
//     flexGrow: 1,
//   },
//   link: {
//     margin: theme.spacing(1, 1.5),
//   },
//   heroContent: {
//     padding: theme.spacing(8, 0, 6),
//   },
//   cardHeader: {
//     backgroundColor:
//       theme.palette.type === "light"
//         ? theme.palette.grey[200]
//         : theme.palette.grey[700],
//   },
//   cardPricing: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "baseline",
//     marginBottom: theme.spacing(2),
//   },
//   footer: {
//     borderTop: `1px solid ${theme.palette.divider}`,
//     marginTop: theme.spacing(8),
//     paddingTop: theme.spacing(3),
//     paddingBottom: theme.spacing(3),
//     [theme.breakpoints.up("sm")]: {
//       paddingTop: theme.spacing(6),
//       paddingBottom: theme.spacing(6),
//     },
//   },
// }));

const titles = {
  title: "Therapy and Support Sponsorships",
  aTitle: "روح واحدة: كفالات العلاج والدعم",
  subtitle: "Sponsor your Muslim brothers and sisters for therapy and support",
  aSubtitle: "اكفل إخوانك المسلمين وأخواتك المسلمات من أجل علاجهم ودعمهم",
  description:
    'Allah\'s Messenger (ﷺ) said, "A Muslim is a brother of another Muslim, so he should not oppress him, nor should he hand him over to an oppressor. Whoever fulfilled the needs of his brother, Allah will fulfill his needs; whoever brought his (Muslim) brother out of a discomfort, Allah will bring him out of the discomforts of the Day of Resurrection, and whoever screened a Muslim, Allah will screen him on the Day of Resurrection . " ',
  aDescription:
    'إن رسول الله ﷺ قال:"المُسْلِمِ أخُو المُسْلِمِ، لا يَظْلِمُهُ ولا يُسْلِمُهُ، مَن كانَ في حاجَةِ أخِيهِ كانَ اللَّهُ في حاجَتِهِ، ومَن فَرَّجَ عن مُسْلِمٍ كُرْبَةً، فَرَّجَ اللَّهُ عنْه بها كُرْبَةً مِن كُرَبِ يَومِ القِيامَةِ، ومَن سَتَرَ مُسْلِمًا سَتَرَهُ اللَّهُ يَومَ القِيامَةِ."',
  letterTitle: "Program Description",
  aLetterTitle: "وصف البرنامج",
  letterp1: "Assalamu alaikom,",
  aLetterp1: "السلام عليكم،",
  letterp2:
    "Our sponsorship program seeks to help Muslim men and women who have experienced family trauma and childhood abuse, subsequently developed shame and low self-esteem, been prone to bullying and abuse, and developed addictions (such as pornography addictions, sex addictions) and/or unwanted same-sex attractions.",
  aLetterp2:
    "برنامج الكفالة يهدف إلى مساعدة المسلمين الرجال والمسلمات النساء الذين اختبروا صدمات نفسية عائلية و تحرشات في الطفولة، ونجم نتيجة لذلك الخزي وضعف الثقة بالنفس وضعف تقدير الذات وأصبحوا معرضين للتنمر والتحرش، وطوّروا إدمانات (مثل إدمانات الإباحية، الإدمانات الجنسية) و/أو انجذابات مثلية جنسية غير مرغوبة.",
  letterp3:
    "Therapy and support groups are indispensable in the healing journey of these men and women. Proper cognitive behavioral therapy (CBT), trauma-based therapy, reintegrative therapy, 12-step programs and other fellowship programs, to name a few, have been shown to be effective in overcoming traumas, experiencing self-worth and restoring one’s sense of well-being and overall functioning. However, many Muslim men and women cannot afford some of these opportunities given the required financial and time commitments. As a result, many men and women would experience a deterioration in their spiritual, mental, emotional and physical well-being, with some contemplating or even attempting suicide. Through our sponsorship program, we hope to circumvent these financial problems to give those men and women a new chance at life.",
  aLetterp3:
    "مجموعات العلاج والدعم هي لا غنى عنها في رحلة العلاج لهؤلاء الرجال والنساء. العلاج السلوكي المعرفي المناسب (CBT)، العلاج القائم على الصدمة النفسية، العلاج بإعادة الدمج، برامج الاثنا عشر خطوة المجانية والزمالات الأخرى، بعض منها، قد أثبتت فاعليتها في التغلب على الصدمات النفسية، اختبار جدارة الذات وترميم إحساس الشخص بالعافية وجعله عضو منتج إجمالاً. ولكن العديد من المسلمين الرجال والنساء ليس بمقدورهم سداد تلك الفرص العلاجية التي تتطلب التزاماً مادياً وزمنياً. وكنتيجة لذلك فإن العديد من الرجال والنساء سوف يختبرون تدهوراً في وضعهم الروحي، العقلي، العاطفي والبدني وبعضهم يفكر أو حتى يقدم على الانتحار.",
  letterp4:
    "Every person is valuable. Every person deserves hope and new chances. Your donation can help save a life.",
  aLetterp4:
    "نحن نحاول من خلال برنامجنا للكفالة بأن نغطي مشاكل النفقات المالية لمنح هؤلاء الرجال والنساء فرصة جديدة في الحياة. حياة كل شخص غالية ولا تقدر بثمن. كل شخص يستحق الأمل وفرصاً أفضل للعيش. بتبرعك قد ينقذ حياة أحدهم.",
  letterp5:
    "{... And whoever saves one life - it is as if he had saved mankind entirely ...} Al-Ma’idah, 32.",
  aLetterp5:
    "{... وَمَنْ أَحْيَاهَا فَكَأَنَّمَا أَحْيَا النَّاسَ جَمِيعًا ۚ …} المائدة، آية ٣٢. ",
  letterp6: "Jazakom Allah khairan.",
  aLetterp6: "جزاكم الله خيراً",
  donate: "Donate",
  aDonate: "تبرع",
  operateTitle: "How We Operate",
  aOperateTitle: "كيف نعمل",
  operatep1:
    "Our sponsorship program acts as a liaison between sponsors interested in supporting an individual’s therapy journey, the individual seeking therapy/support, and the therapist/therapy organization/support group. We have a list of qualified and licensed therapists who employ evidence-based techniques in their practices as well as coaches in support organizations who are willing to help our endeavor. Clients choose their preferred options, send us a pre-filled form, and wait until enough funds are available to cover the therapy/support duration. Once funds are available, we contact clients and connect them to the therapy/support option of their choice.",
  aOperatep1:
    "برنامجنا للكفالة يعمل كوسيط بين الكفيلين المهتمين في دعم الرحلة العلاجية للفرد و الفرد الذي يبحث عن العلاج أو الدعم والمعالج أو المنظمة العلاجية أو مجموعة الدعم. لدينا قائمة من المعالجين الأكفاء والمختصين الذين يقومون بتقنيات مثبتة إكلينيكياً في مزاولاتهم وأيضاً مدربين في المنظمات العلاجية والذين هم مستعدون لمساعدتنا في مساعينا. العملاء يختارون الخيارات العلاجية التي يرغبون بها و يرسلون لنا استمارة معبأة ببياناتهم، وينتظرون حتى يصبح المبلغ كافياً ومتاحاً لتغطية مدة علاجهم/دعمهم. حالما يتوفر المبلغ، نقوم بالتواصل مع العملاء ونقوم بتحويلهم إلى الخيار العلاجي أو الدعم الذي تم اختياره من قِبَلهم. ",
  operatep2:
    "Another alternative would be for the sponsor, if they wish, to send the money directly on the client’s behalf to the therapy/support option chosen by the client.",
  aOperatep2:
    "قد يكون هناك بديل آخر للكفيل، إن أحب، وهو إرسال المال مباشرة بالنيابة عن العميل إلى الخيار العلاجي/الدعم المختار من قِبَل العميل.",
  operatep3:
    "If you would like to know more or if you have any questions, please fill out the contact form and we will get back to you as soon as possible, inshaAllah.",
  aOperatep3:
    "إن رغبت في معرفة المزيد أو إن كان لديك أي سؤال، الرجاء ملئ استمارة الاتصال وسوف نقوم بالرد عليك في أقرب وقت إن شاء الله.",
  contact: "Contact Us",
  aContact: "اتصل بنا",
  name: "Name",
  aName: "الاسم",
  email: "Email address",
  aEmail: "البريد الإلكتروني",
  message: "Message",
  aMessage: "الرسالة",
  namePlace: "Enter name",
  aNamePlace: "أدخل الاسم",
  emailPlace: "Enter email",
  aEmailPlace: "أدخل البريد الإلكتروني",
  share: "We'll never share your email with anyone else.",
  aShare: "لن نشارك بريدك الإلكتروني مع أي شخص آخر.",
  messagePlace: "Type your message here...",
  aMessagePlace: "اكتب رسالتك هنا...",
  copyright: "Copyright © Straight Struggle 2020.",
  aCopyright: "حقوق الطبع والنشر © Straight Struggle 2020.",
  recurring: "Would you like the payment to be recurring?",
  aRecurring: "هل ترغب في تكرار الدفعة؟",
  yes: "Yes",
  aYes: "نعم",
  no: "No",
  aNo: "كلا",
  often: "How often?",
  aOften: "كم مرة؟",
  weekly: "Weekly",
  aWeekly: "أسبوعي",
  monthly: "Monthly",
  aMonthly: "شهريا",
  back: "Back",
  aBack: "عودة",
  ts: "Would you like to include the transaction fee?",
  aTs: "هل ترغب في تضمين رسوم المعاملات؟",
  much: "How much would you like to donate?",
  aMuch: "كم تريد التبرع؟",
  purpose: "This form is only for contact purposes. To donate, click",
  apurpose: "هذا النموذج هو فقط للاتصال. للتبرع ، اضغط",
};
